import { SmsRetriever } from '@ionic-native/sms-retriever';
const pattern = /\d+/;
class AutoFetchOtpService {
  getApplicationHash() {
    SmsRetriever.getAppHash()
      .then((res: any) => console.log(res))
      .catch((error: any) => console.error(error));
  }
  public async getMessages(): Promise<string> {
    try {
      const res: any = await SmsRetriever.startWatching();
      return this.interceptOtpFromMessage(res.Message);
    } catch (error: any) {
      return '';
    }
  }

  interceptOtpFromMessage(smsString: string): string {
    const match = smsString.match(pattern);
    return match?.[0] || '';
  }
}
export const AutoFetch = new AutoFetchOtpService();
